module.exports = __webpack_public_path__ + "img/alert.9ec1e594.png";